import { CommonDateRange, GooglePlaceFilter } from "components/common";
import CustomSelect from "components/CustomSelect";
import React, { useEffect, useState } from "react";
import { useMemo } from "react";
import { MdOutlineCancel } from "react-icons/md";
import { RiResetLeftFill } from "react-icons/ri";

const roles = [
  { label: "All", value: "" },
  { label: "User", value: 1 },
  { label: "Admin", value: 2 },
];

const statusOptions = [
  { label: "All", value: "" },
  { label: "Active", value: true },
  { label: "Inactive", value: false },
];

const registerOptions = [
  { label: "All", value: "" },
  { label: "Yes", value: 1 },
  { label: "No", value: 0 },
];

const sourceTypeOptions = [
  { label: "All", value: "" },
  { label: "Push", value: 1 },
  { label: "Email", value: 2 },
];

const sifarishTypeOptions = [
  { label: "All", value: "" },
  { label: "CREATE SIFARISH", value: "CREATE_SIFARISH" },
  { label: "SAVE SIFARISH", value: "SAVE_SIFARISH" },
  { label: "FORWARD SIFARISH", value: "FORWARD_SIFARISH" },
  { label: "HELPFUL SIFARISH", value: "HELPFUL_SIFARISH" },
  { label: "ADMIN BONUS", value: "ADMIN_BONUS" },
];

const ButtonHeading = (props) => {
  const getMasterData = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("masterData"));
    } catch {
      return null;
    }
  }, []);

  let {
    title,
    onClick,
    buttonTitle = "Add",
    showSearchFilter,
    onClickFilterModal,
    filter,
    setFilter,
    printButtonTitle,
    printOnClick,
    isShow,
    Export,
    ExportSubmit,
    exportLoad,
    Print,
    PrintSubmit,
    Edit,
    tripDetais,
    endTripTitle,
    endTripOnClick,
    showDateRange,
    selectedRange,
    handleApply,
    onClickEdit,
    ChangeStatus,
    onClickChangeStatus,
    isDelete,
    onHandleDelete,
    titleName,
    handleRemoveTitle,
    showCross,
    userDataList = [],
    handleActiveFunction,
    activeTitleTxt,
    handleAddSifarish,
    addSifarishTitle,
    showResetFilter,
    handleReset,
    handleBackButton,
    extraRightContent,
  } = props;

  const [categoryStatusList, setCategoryStatusList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [birdStatusList, setBirdStatusList] = useState([]);
  const [userList, setUserList] = useState([]);

  useEffect(() => {
    const categories = getMasterData?.categories;

    if (Array.isArray(categories) && categories.length) {
      const categoryList = categories.map((i) => ({
        label: i?.title,
        value: i?._id,
      }));
      setCategoryStatusList([{ label: "All", value: "" }, ...categoryList]);
    }
  }, [getMasterData]);

  useEffect(() => {
    if (Array.isArray(userDataList) && userDataList?.length) {
      const categoryList = userDataList.map((i) => ({
        label: `${i?.firstName} ${i?.lastName}`,
        value: i?._id,
      }));
      setUserList([{ label: "All", value: "" }, ...categoryList]);
    }
  }, [userDataList]);

  useEffect(() => {
    const selectedCategory = getMasterData?.categories?.find(
      (cat) => cat._id === filter?.categoryIds
    );

    if (selectedCategory?.subCategories?.length) {
      const subList = selectedCategory.subCategories.map((sub) => ({
        label: sub.title,
        value: sub._id,
      }));
      setSubCategoryList([{ label: "All", value: "" }, ...subList]);
    } else {
      setSubCategoryList([]);
    }
  }, [filter?.categoryIds]);

  useEffect(() => {
    const birds = getMasterData?.birds;

    if (Array.isArray(birds) && birds.length) {
      const birdList = birds.map((i) => ({
        label: i?.title,
        value: i?._id,
      }));
      setBirdStatusList([{ label: "All", value: "" }, ...birdList]);
    }
  }, [getMasterData]);

  const handleResetInternal = () => {
    setCategoryStatusList((prev) => {
      const allOption = { label: "All", value: "" };
      const others = prev.filter((opt) => opt.value !== "");
      return [allOption, ...others];
    });

    // setSubCategoryList((prev) => {
    //   const allOption = { label: "All", value: "" };
    //   const others = prev.filter((opt) => opt.value !== "");
    //   return [allOption, ...others];
    // });

    setBirdStatusList((prev) => {
      const allOption = { label: "All", value: "" };
      const others = prev.filter((opt) => opt.value !== "");
      return [allOption, ...others];
    });

    setUserList((prev) => {
      const allOption = { label: "All", value: "" };
      const others = prev.filter((opt) => opt.value !== "");
      return [allOption, ...others];
    });
  };

  return (
    <div className="contentHead">
      <div className="_allFilts_fxs">
        <h4>{title}</h4>
        <h4>{titleName}</h4>
        {showCross && (
          <div
            style={{
              marginBottom: "5px",
              cursor: "pointer",
              color: "var(--reject-red)",
            }}
            onClick={() => handleRemoveTitle()}
          >
            <MdOutlineCancel />
          </div>
        )}
      </div>

      <div className="_allFilts_fxs">
        {isShow?.category && (
          <div>
            <CustomSelect
              options={categoryStatusList}
              value={categoryStatusList.find(
                // (i) => i.value === filter?.categoryIds || categoryStatusList[0]
                (i) => i.value === filter?.categoryIds
              )}
              name="category"
              label="Select Category"
              placeholder="Select Category"
              onSelect={(data) => {
                setFilter((prev) => ({
                  ...prev,
                  page: 1,
                  categoryIds: data?.value,
                  subCategoryId: "",
                }));
              }}
            />
          </div>
        )}

        {isShow?.userRole && (
          <div>
            <CustomSelect
              options={roles}
              value={roles.find((opt) => opt.value === filter?.userRole)}
              name="userRole"
              label="User Role"
              placeholder="Select User Role"
              onSelect={(data) =>
                setFilter((prev) => ({
                  ...prev,
                  userRole: data?.value,
                  page: 1,
                }))
              }
            />
          </div>
        )}

        {isShow?.selectedUser && (
          <div>
            <CustomSelect
              options={userList}
              value={userList.find(
                // (opt) => opt.value === filter?.selectedUser || userList[0]
                (opt) => opt.value === filter?.selectedUser
              )}
              name="userId"
              label="User"
              placeholder="Select User "
              onSelect={(data) =>
                setFilter((prev) => ({
                  ...prev,
                  userId: data?.value,
                  page: 1,
                }))
              }
            />
          </div>
        )}

        {isShow?.isActive && (
          <div>
            <CustomSelect
              options={statusOptions}
              value={statusOptions.find(
                (opt) => opt.value === filter?.isActive
              )}
              name="isActive"
              label="Status"
              placeholder="Select Status"
              onSelect={(data) =>
                setFilter((prev) => ({
                  ...prev,
                  isActive: data?.value,
                  page: 1,
                }))
              }
            />
          </div>
        )}

        {isShow?.isRegistered && (
          <div>
            <CustomSelect
              options={registerOptions}
              value={registerOptions.find(
                (opt) => opt.value === filter?.isRegistered
              )}
              name="isRegistered"
              label="Register"
              placeholder="Select Register"
              onSelect={(data) =>
                setFilter((prev) => ({
                  ...prev,
                  isRegistered: data?.value,
                  page: 1,
                }))
              }
            />
          </div>
        )}
        {isShow?.isSourceType && (
          <div>
            <CustomSelect
              options={sourceTypeOptions}
              value={sourceTypeOptions.find(
                (opt) => opt.value === filter?.sourceType
              )}
              name="sourceType"
              label="Source Type"
              placeholder="Select Type"
              onSelect={(data) =>
                setFilter((prev) => ({
                  ...prev,
                  sourceType: data?.value,
                  page: 1,
                }))
              }
            />
          </div>
        )}

        {isShow?.isSifarishType && (
          <div>
            <CustomSelect
              options={sifarishTypeOptions}
              value={sifarishTypeOptions.find(
                (opt) => opt.value === filter?.type
              )}
              name="type"
              label="Award Type"
              placeholder="Award Type"
              onSelect={(data) =>
                setFilter((prev) => ({
                  ...prev,
                  type: data?.value,
                  page: 1,
                }))
              }
            />
          </div>
        )}

        {isShow?.subcategory && subCategoryList.length > 0 && (
          <div>
            <CustomSelect
              options={subCategoryList}
              value={subCategoryList.find(
                // (i) => i.value === filter?.subCategoryId || subCategoryList[0]
                (i) => i.value === filter?.subCategoryId
              )}
              name="subcategory"
              label="Select Subcategory"
              placeholder="Select Subcategory"
              onSelect={(data) =>
                setFilter((prev) => ({
                  ...prev,
                  subCategoryId: data?.value,
                  page: 1,
                }))
              }
            />
          </div>
        )}

        {isShow?.birds && (
          <div>
            <CustomSelect
              options={birdStatusList}
              value={birdStatusList.find(
                // (i) => i.value === filter?.birdId || birdStatusList[0]
                (i) => i.value === filter?.birdId
              )}
              name="bird"
              label="Select Bird"
              placeholder="Select Bird"
              onSelect={(data) => {
                setFilter((prev) => ({
                  ...prev,
                  page: 1,
                  birdId: data?.value,
                }));
              }}
            />
          </div>
        )}

        {isShow?.searchWithCity && (
          <div className="_inpW_search _lrl_inpSrch">
            <GooglePlaceFilter
              onAddressChange={({ city, state, country }) => {
                setFilter((prev) => ({
                  ...prev,
                  city,
                  state,
                  country,
                  page: 1,
                }));
              }}
              placeholder="Search city"
            />
          </div>
        )}

        {isShow?.keyword && (
          <div className="_inpW_search _lrl_inpSrch">
            <svg
              className="srcIcon"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                opacity="0.2"
                d="M17.347 16.3507L12.7293 11.733C13.8389 10.4008 14.3923 8.69214 14.2742 6.96238C14.1562 5.23263 13.3757 3.61498 12.0954 2.44596C10.815 1.27695 9.13319 0.64656 7.39985 0.685944C5.66652 0.725329 4.0151 1.43145 2.78913 2.65742C1.56317 3.88339 0.857043 5.53481 0.817658 7.26814C0.778274 9.00147 1.40866 10.6833 2.57768 11.9636C3.7467 13.244 5.36434 14.0244 7.0941 14.1425C8.82385 14.2606 10.5325 13.7072 11.8647 12.5976L16.4824 17.2153L17.347 16.3507ZM2.06069 7.43204C2.06069 6.34363 2.38344 5.27967 2.98812 4.3747C3.5928 3.46972 4.45227 2.76438 5.45782 2.34787C6.46337 1.93135 7.56985 1.82238 8.63734 2.03471C9.70483 2.24705 10.6854 2.77117 11.455 3.54078C12.2246 4.3104 12.7487 5.29095 12.9611 6.35844C13.1734 7.42593 13.0644 8.53241 12.6479 9.53797C12.2314 10.5435 11.5261 11.403 10.6211 12.0077C9.71611 12.6124 8.65215 12.9351 7.56375 12.9351C6.10474 12.9335 4.70596 12.3532 3.67428 11.3215C2.64261 10.2898 2.0623 8.89104 2.06069 7.43204Z"
                fill="black"
              ></path>
            </svg>
            <input
              type="text"
              placeholder="Search"
              className="simpleFilter_input"
              autoComplete="off"
              value={filter?.keyword}
              onChange={(e) =>
                setFilter((s) => ({
                  ...s,
                  keyword: e.target.value,
                  page: 1,
                }))
              }
            />
          </div>
        )}

        {showSearchFilter?.search && (
          <div className="_inpW_search _lrl_inpSrch">
            <svg
              className="srcIcon"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                opacity="0.2"
                d="M17.347 16.3507L12.7293 11.733C13.8389 10.4008 14.3923 8.69214 14.2742 6.96238C14.1562 5.23263 13.3757 3.61498 12.0954 2.44596C10.815 1.27695 9.13319 0.64656 7.39985 0.685944C5.66652 0.725329 4.0151 1.43145 2.78913 2.65742C1.56317 3.88339 0.857043 5.53481 0.817658 7.26814C0.778274 9.00147 1.40866 10.6833 2.57768 11.9636C3.7467 13.244 5.36434 14.0244 7.0941 14.1425C8.82385 14.2606 10.5325 13.7072 11.8647 12.5976L16.4824 17.2153L17.347 16.3507ZM2.06069 7.43204C2.06069 6.34363 2.38344 5.27967 2.98812 4.3747C3.5928 3.46972 4.45227 2.76438 5.45782 2.34787C6.46337 1.93135 7.56985 1.82238 8.63734 2.03471C9.70483 2.24705 10.6854 2.77117 11.455 3.54078C12.2246 4.3104 12.7487 5.29095 12.9611 6.35844C13.1734 7.42593 13.0644 8.53241 12.6479 9.53797C12.2314 10.5435 11.5261 11.403 10.6211 12.0077C9.71611 12.6124 8.65215 12.9351 7.56375 12.9351C6.10474 12.9335 4.70596 12.3532 3.67428 11.3215C2.64261 10.2898 2.0623 8.89104 2.06069 7.43204Z"
                fill="black"
              ></path>
            </svg>
            <input
              type="text"
              placeholder="Search"
              className="simpleFilter_input"
              autoComplete="off"
              value={filter?.search}
              onChange={(e) =>
                setFilter((s) => ({ ...s, search: e.target.value, page: 1 }))
              }
            />
          </div>
        )}

        {showSearchFilter?.filterOption && (
          <div className="column-toggle-dropdown" onClick={onClickFilterModal}>
            <button className="column-toggle-dropdown-toggle">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="11"
                viewBox="0 0 11 11"
                fill="none"
              >
                <path
                  d="M4.90652 10.7371C4.71844 10.7371 4.56079 10.6735 4.43354 10.5463C4.3063 10.419 4.24267 10.2614 4.24267 10.0733V6.09015L0.276151 1.02828C0.121261 0.840193 0.0991417 0.641038 0.209766 0.430809C0.320417 0.22058 0.491904 0.115479 0.724252 0.115479H10.4165C10.6489 0.115479 10.8204 0.22058 10.931 0.430809C11.0416 0.641038 11.0195 0.840193 10.8646 1.02828L6.89808 6.09015V10.0733C6.89808 10.2614 6.83449 10.419 6.70724 10.5463C6.57999 10.6735 6.42234 10.7371 6.23423 10.7371H4.90652Z"
                  fill="#142B4B"
                ></path>
              </svg>
              Filter
            </button>
          </div>
        )}

        {endTripTitle && tripDetais?.trip_status != (4 || 5) && (
          <div className="_rSideBtn" onClick={endTripOnClick}>
            <button className="_addComm_btn _builtyPrintBtn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="19"
                viewBox="0 0 20 19"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16.5 18.3091H3.5C2.57174 18.3091 1.6815 17.9404 1.02513 17.284C0.368749 16.6276 0 15.7374 0 14.8091V1.75212C0 0.685123 1.056 0.00812271 1.985 0.330123C2.118 0.376123 2.248 0.443123 2.372 0.532123L2.547 0.657123C2.97266 0.95915 3.48188 1.12098 4.0038 1.12008C4.52572 1.11918 5.03438 0.95561 5.459 0.652123C6.05504 0.227937 6.76843 0 7.5 0C8.23157 0 8.94496 0.227937 9.541 0.652123C9.96562 0.95561 10.4743 1.11918 10.9962 1.12008C11.5181 1.12098 12.0273 0.95915 12.453 0.657123L12.628 0.532123C13.621 -0.177877 15 0.532123 15 1.75212V9.30912H18.5C18.6989 9.30912 18.8897 9.38814 19.0303 9.52879C19.171 9.66945 19.25 9.86021 19.25 10.0591V15.5591C19.25 16.2885 18.9603 16.9879 18.4445 17.5037C17.9288 18.0194 17.2293 18.3091 16.5 18.3091ZM15.25 10.8091V15.5591C15.25 15.8906 15.3817 16.2086 15.6161 16.443C15.8505 16.6774 16.1685 16.8091 16.5 16.8091C16.8315 16.8091 17.1495 16.6774 17.3839 16.443C17.6183 16.2086 17.75 15.8906 17.75 15.5591V10.8091H15.25ZM11 6.55912C11 6.36021 10.921 6.16945 10.7803 6.02879C10.6397 5.88814 10.4489 5.80912 10.25 5.80912H4.25C4.05109 5.80912 3.86032 5.88814 3.71967 6.02879C3.57902 6.16945 3.5 6.36021 3.5 6.55912C3.5 6.75804 3.57902 6.9488 3.71967 7.08945C3.86032 7.2301 4.05109 7.30912 4.25 7.30912H10.25C10.4489 7.30912 10.6397 7.2301 10.7803 7.08945C10.921 6.9488 11 6.75804 11 6.55912ZM10 9.55912C10 9.36021 9.92098 9.16945 9.78033 9.02879C9.63968 8.88814 9.44891 8.80912 9.25 8.80912H4.25C4.05109 8.80912 3.86032 8.88814 3.71967 9.02879C3.57902 9.16945 3.5 9.36021 3.5 9.55912C3.5 9.75804 3.57902 9.9488 3.71967 10.0895C3.86032 10.2301 4.05109 10.3091 4.25 10.3091H9.25C9.44891 10.3091 9.63968 10.2301 9.78033 10.0895C9.92098 9.9488 10 9.75804 10 9.55912ZM10.25 11.8091C10.4489 11.8091 10.6397 11.8881 10.7803 12.0288C10.921 12.1694 11 12.3602 11 12.5591C11 12.758 10.921 12.9488 10.7803 13.0895C10.6397 13.2301 10.4489 13.3091 10.25 13.3091H4.25C4.05109 13.3091 3.86032 13.2301 3.71967 13.0895C3.57902 12.9488 3.5 12.758 3.5 12.5591C3.5 12.3602 3.57902 12.1694 3.71967 12.0288C3.86032 11.8881 4.05109 11.8091 4.25 11.8091H10.25Z"
                  fill="white"
                />
              </svg>
              {endTripTitle}
            </button>
          </div>
        )}
        {printButtonTitle && printOnClick && (
          <div className="_rSideBtn" onClick={printOnClick}>
            <button className="_addComm_btn _builtyPrintBtn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <path
                  d="M12 12C12.1837 12 12.361 12.0675 12.4983 12.1895C12.6356 12.3116 12.7233 12.4798 12.7448 12.6622L12.75 12.75V15.75C12.75 15.9337 12.6825 16.111 12.5605 16.2483C12.4384 16.3856 12.2702 16.4733 12.0878 16.4948L12 16.5H6C5.8163 16.5 5.639 16.4325 5.50172 16.3105C5.36444 16.1884 5.27674 16.0202 5.25525 15.8378L5.25 15.75V12.75C5.25002 12.5663 5.31747 12.389 5.43954 12.2517C5.56161 12.1144 5.72981 12.0267 5.91225 12.0052L6 12H12ZM14.25 5.25C14.8467 5.25 15.419 5.48705 15.841 5.90901C16.2629 6.33097 16.5 6.90326 16.5 7.5V12.75C16.5 13.1478 16.342 13.5294 16.0607 13.8107C15.7794 14.092 15.3978 14.25 15 14.25H14.25V12C14.25 11.6022 14.092 11.2206 13.8107 10.9393C13.5294 10.658 13.1478 10.5 12.75 10.5H5.25C4.85218 10.5 4.47064 10.658 4.18934 10.9393C3.90804 11.2206 3.75 11.6022 3.75 12V14.25H3C2.60218 14.25 2.22064 14.092 1.93934 13.8107C1.65804 13.5294 1.5 13.1478 1.5 12.75V7.5C1.5 6.90326 1.73705 6.33097 2.15901 5.90901C2.58097 5.48705 3.15326 5.25 3.75 5.25H14.25ZM12.75 6.75H11.25C11.0588 6.75021 10.875 6.82341 10.736 6.95464C10.597 7.08586 10.5133 7.26521 10.5021 7.45605C10.4909 7.64688 10.553 7.83478 10.6757 7.98137C10.7984 8.12796 10.9724 8.22217 11.1623 8.24475L11.25 8.25H12.75C12.9412 8.24979 13.125 8.17659 13.264 8.04536C13.403 7.91414 13.4867 7.73479 13.4979 7.54395C13.5091 7.35312 13.447 7.16522 13.3243 7.01863C13.2016 6.87204 13.0276 6.77783 12.8378 6.75525L12.75 6.75ZM12.75 1.5C12.9489 1.5 13.1397 1.57902 13.2803 1.71967C13.421 1.86032 13.5 2.05109 13.5 2.25V3.75H4.5V2.25C4.5 2.05109 4.57902 1.86032 4.71967 1.71967C4.86032 1.57902 5.05109 1.5 5.25 1.5H12.75Z"
                  fill="white"
                />
              </svg>
              {printButtonTitle}
            </button>
          </div>
        )}

        {Print && (
          <div className="_rSideBtn" onClick={PrintSubmit}>
            <button className="_addComm_btn"> Print </button>
          </div>
        )}

        {ChangeStatus && (
          <div className="_rSideBtn" onClick={onClickChangeStatus}>
            <button className="_addComm_btn"> Change Status </button>
          </div>
        )}

        {Edit && (
          <div className="_rSideBtn" onClick={onClickEdit}>
            <button className="_addComm_btn"> Edit </button>
          </div>
        )}
        {isDelete && (
          <div className="_rSideBtn" onClick={onHandleDelete}>
            <button
              className="_addComm_btn"
              style={{ background: "var(--reject-red)" }}
            >
              Delete
            </button>
          </div>
        )}

        {showDateRange && (
          <div className="__dateFilter">
            <CommonDateRange
              initialStartDate={selectedRange.startDate || ""}
              initialEndDate={selectedRange.endDate || ""}
              onApply={handleApply}
            />
          </div>
        )}

        {showResetFilter && (
          <span
            style={{ cursor: "pointer" }}
            onClick={() => {
              handleReset();
              handleResetInternal();
            }}
          >
            <RiResetLeftFill />
          </span>
        )}
        {buttonTitle && onClick && (
          <div className="_rSideBtn" onClick={onClick}>
            <button className="_addComm_btn">{buttonTitle}</button>
          </div>
        )}

        {isShow?.isActiveUser && (
          <button className="_addComm_btn " onClick={handleActiveFunction}>
            {activeTitleTxt}
          </button>
        )}

        {isShow?.isAddSifarish && (
          <button className="_addComm_btn " onClick={handleAddSifarish}>
            {addSifarishTitle}
          </button>
        )}

        {Export && (
          <div className="_rSideBtn" onClick={ExportSubmit}>
            <button disabled={exportLoad} className="_addComm_btn">
              {exportLoad ? "Exporting" : "Export"}
            </button>
          </div>
        )}

        {extraRightContent}

        {isShow?.isBackButton && (
          <button className="_addComm_btn" onClick={handleBackButton}>
            Back
          </button>
        )}
      </div>
    </div>
  );
};

export default ButtonHeading;
